<rid-demo-page [title]="'Component Lab'" previousRoute="/">
  <rid-button class="w-full" content="<rid-button>" variant="PRIMARY" routerLink="button" />
  <rid-button class="w-full" content="<rid-content-card>" variant="PRIMARY" routerLink="content-card" />
</rid-demo-page>
